import React, { useEffect, useRef, useState } from 'react';
import IconsScroller from '../../common/IconsScroller';
import { calculateNumberOfRows, MAXIMUM_NUMBER_OF_ROWS } from '../../scroller-utils';
import { getConfiguration } from '../../data/utils';

function ButtonsContainer(props) {
    const iconsContainer = useRef(null);
    const ROWS_LIMIT = props.maxNumOfRows || MAXIMUM_NUMBER_OF_ROWS;
    const buttons = props.buttons || props.children;
    // Se la dimensione del container dei bottoni cambia, disabilita lo scroller
    // e ricalcola nuovamente se abilitarlo
    const [containerWidth, setContainerWidth] = useState(null);
    const [toggleGridCheck, setToggleGridCheck] = useState(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const computedWidth = window.getComputedStyle(iconsContainer.current)['width'];
        if (computedWidth !== containerWidth) {
            setContainerWidth(computedWidth);
            if (containerWidth != null) {
                //setScrollerEnabled(false);
                setToggleGridCheck(prev => !prev);
            }
        }
    });

    // Al ridimensionamento della finestra verifica se usare lo scroller
    useEffect(() => {
        function resizeListener() {
            setToggleGridCheck(prev => !prev)
        }
        window.addEventListener('resize', resizeListener);
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, []);

    // Impost se lo scroller � abilitato in base al numero di righe dei bottoni
    const [scrollerEnabled, setScrollerEnabled] = useState(false);
    const conf = getConfiguration();

    useEffect(() => {
        if (!props.forceRows && iconsContainer.current != null && (!props.isLiveCompetition || !scrollerEnabled)) {//In LiveCompetition component the scroller is enabled only at first time, otherwhise subsequent enabled/disabled state may cause flickering
            let numberOfRows = calculateNumberOfRows(iconsContainer.current, ROWS_LIMIT);
            if (numberOfRows > ROWS_LIMIT) {
                setScrollerEnabled(true);
            } else if (numberOfRows !== ROWS_LIMIT) { // Chiudo lo scroller solo se  numberOfRows!=maximumNumberOfRows
                setScrollerEnabled(false);
            }
        }
    }, [props.forceRows, props.aggregate, buttons, toggleGridCheck]);

    return (
        <>

        {conf.iwh ?
        
            !props.forceRows && scrollerEnabled ?
                <div className="">
                    <div ref={iconsContainer} className={" " + (props.aggregate ? 'aggregate' : 'elenco-macro')}>
                        {buttons.length > 0 && buttons}
                    </div>
                    <IconsScroller id={props.id} buttons={buttons} iconsContainer={iconsContainer.current} scrollOffset={props.scrollOffset} />
                </div>
                :
                <div className="">
                    <div ref={iconsContainer} className={" " + (props.aggregate ? 'aggregate' : 'elenco-macro')}>
                        {buttons.length > 0 && buttons}

                    </div>
                </div>
        
        :
        !props.forceRows && scrollerEnabled ?
                <div className="parentDropdown box-grid-2 paddles-buttons-2 has-icons-container-no-wrap">
                    <div ref={iconsContainer} className={"containerElementiDropdown horiz-sc icons-container icons-container-no-wrap " + (props.aggregate ? 'aggregate' : 'elenco-macro')}>
                        {buttons.length > 0 && buttons}
                    </div>
                    <IconsScroller id={props.id} buttons={buttons} iconsContainer={iconsContainer.current} scrollOffset={props.scrollOffset} />
                </div>
                :
                <div className="parentDropdown box-grid-2 paddles-buttons-2">
                    <div ref={iconsContainer} className={"containerElementiDropdown horiz-sc icons-container force-grid-view " + (props.aggregate ? 'aggregate' : 'elenco-macro')}>              
                        {buttons.length > 0 && buttons}
                    </div>
                  
                </div>
        
        }
        </>
    );
}

export default ButtonsContainer;